// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"60c482ad","488":"baf49bf8"}[chunkId] + ".chunk.js";
};